import * as yup from "yup";

export default yup.string().matches(/^[A-Za-z 0-9]+$/i, "Invalid Input");
